import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { UserService } from '../../../../../services/user/user-service/user.service';
import { StudentProfileService } from '../../services/student-profile.service';
import { Parent } from '../../../../../models/parent';
import { ProfileInfo } from '../../../../../models/profile-info';
import { StudentProfileInfo } from '../../models/student-profile-info';
import { flatMap } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { PermissionService } from '../../../../../services/permission/permission.service';
import { UniqueEmailValidator } from '../../validators/unique-email-validator';
import { UniqueMobileValidator } from '../../validators/unique-mobile-validator';
import { EditProfileService } from '../../services/edit-profile.service'
import { PrifactRoute } from 'src/app/models/prifact-route';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent extends ComponentBase implements OnInit {

  profileInfo: ProfileInfo;
  studentInfo: StudentProfileInfo;
  userInfo: Parent;
  editForm: FormGroup;
  submitted = false;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(private userService: UserService
    , private studentProfileService: StudentProfileService
    , private formBuilder: FormBuilder
    , private routingService: RoutingService
    , private permissionService: PermissionService
    , private editProfileService: EditProfileService
  ) {
    super();
  }

  errorMessage: string = null;

  ngOnInit() {
    let subscription = this.userService.getLoggedInUser().pipe(
      flatMap(res => {
        this.profileInfo = res;
        return this.studentProfileService.getProfileInfo();
      })
    ).subscribe(res => {
      this.studentInfo = res;
      this.userInfo = this.studentInfo.parents_info.find(o => o.person_id == this.profileInfo.person.person_id);
      this.initForm();
      this.loadValues();
      this.checkPermissionForForm();
    });
    this.addSubscription(subscription);
  }

  initForm() {
    this.editForm = this.formBuilder.group({
      relationship: ['', Validators.required],
      is_local_guardian: [''],
      gender: ['', Validators.required],
      email_address: ['',
        [Validators.required, Validators.email],
        UniqueEmailValidator.createValidator(this.editProfileService, this.userInfo.email_address)],
      mobile_number: ['',
        [Validators.required, Validators.pattern('^[0-9]{10}$')],
        UniqueMobileValidator.createValidator(this.editProfileService, this.userInfo.mobile_number)],
      land_line_number: ['',
        [Validators.required, Validators.pattern('^[0-9]+$')]],
      permanent_address_one: ['', Validators.required],
      permanent_address_two: ['', Validators.required],
      permanent_city: ['', Validators.required],
      permanent_state: ['', Validators.required],
      permanent_country: ['', Validators.required],
      permanent_zip_code: ['',
        [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      sameAddress: [''],
      local_address_one: ['', Validators.required],
      local_address_two: ['', Validators.required],
      local_city: ['', Validators.required],
      local_state: ['', Validators.required],
      local_country: ['', Validators.required],
      local_zip_code: ['',
        [Validators.required, Validators.pattern('^[0-9]{6}$')]],
      occupation: [''],
      qualification: [''],
      designation: [''],
      company_name: [''],
      mother_toungue: ['']
    });
  }

  get form() { return this.editForm.controls; }

  loadValues() {
    this.editForm.patchValue(this.userInfo);
    if (this.userInfo.gender == 0) {
      this.form.gender.setValue('Male');
    }
    else if (this.userInfo.gender == 1) {
      this.form.gender.setValue('Female');
    }
    else {
      this.form.gender.setValue(this.userInfo.gender);
    }
  }

  checkPermissionForForm() {
    this.permissionService.getPermissionsForUser()
      .subscribe((res) => {
        if (res.permissions.indexOf("Can_Edit_Self_Profile") == -1) {
          this.editForm.disable();
        }
        else {
          this.editForm.enable();          
        }
        if (res.permissions.indexOf("Can_Edit_Email_And_MobileNumber") == -1) {
          this.editForm.controls.email_address.disable();
          this.editForm.controls.mobile_number.disable();
        }
        else {
          this.editForm.controls.email_address.enable();
          this.editForm.controls.mobile_number.enable();
        }
      });
  }

  onSubmit() {
    this.submitted = true;

    if (this.editForm.invalid) {
      return;
    }

    let editedParent = new Parent();
    editedParent = this.userInfo;
    Object.assign(editedParent, this.editForm.value);
    this.userService.editUserProfile(editedParent).subscribe(res => {
      this.editForm.patchValue(res);
    }, err => {
      console.error(err)
    });
    this.onCancel();
  }

  onCancel() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'my-account', 'user'];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
  }

  checkAddressValue(val: boolean) {
    if (val === true) {
      this.form.local_address_one.setValue(this.form.permanent_address_one.value);
      this.form.local_address_two.setValue(this.form.permanent_address_two.value);
      this.form.local_city.setValue(this.form.permanent_city.value);
      this.form.local_state.setValue(this.form.permanent_state.value);
      this.form.local_country.setValue(this.form.permanent_country.value);
      this.form.local_zip_code.setValue(this.form.permanent_zip_code.value);
    }
    else {
      this.form.local_address_one.setValue('');
      this.form.local_address_two.setValue('');
      this.form.local_city.setValue('');
      this.form.local_state.setValue('');
      this.form.local_country.setValue('');
      this.form.local_zip_code.setValue('');
    }
  }
}
